<template>
  <a-layout class="layout login-layout" :style="{backgroundImage: 'url('+ bgaUrl +')'}">
    <div class="login-layout__header">
      <img v-if="currentLang === 'zh_CN' || currentLang === 'en_US' || currentLang === 'ko_KR'" class="login-layout__header-logo" width="91" height="39" src="@/assets/logo-yi.e4b5df36.png">
      <select-lang class="login-layout__header-lang lang-set-login"></select-lang>
    </div>
    <a-layout-content class="login-layout__bd sso-ant-layout-content">
      <router-view />
    </a-layout-content>
    <a-layout-footer style="text-align: center">
      <div style="color:#0079FE;"><img width="69" height="2" src="@/assets/login_left.png">
      <span style="margin:0 10px;">易仓科技·引领跨境电商智变</span><img width="69" height="2" src="@/assets/login_right.png"></div>
      <div style="color:#999;">Copyright 2013 - {{ new Date().getFullYear() }} ©深圳易仓科技有限公司.All Rights Reserved</div>
    </a-layout-footer>
  </a-layout>
</template>

<script>
import { mapState } from 'vuex'
import SelectLang from '@/components/GlobalHeader/SelectLang'

export default {
  components: {
    SelectLang
  },
  computed: {
    ...mapState({
      currentLang: state => state.app.lang
    })
  },
  data () {
    return {
      bgaUrl: require('@/assets/TVYTbAXWheQpRcWDaDMu.svg')
    }
  }
}
</script>

<style lang="less" scoped>
  .login-layout {
    width: 100%;
    height: 100vh;
    // background-image: url(../assets/TVYTbAXWheQpRcWDaDMu.svg);
    background-repeat: no-repeat;
    background-position: center 110px;
    background-size: 100%;
    overflow: auto;
    &__header {
      position: fixed;
      top: 0;
      width: 100%;
      height: 60px;
      background: #F0F3F5;
      box-shadow: -6px 0px 18px 3px rgba(0, 0, 0, 0.04);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px;
      .icon-svg {font-size: 140px;}
      &-logo {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
      &-lang {
        color: #444;line-height: 60px;
      }
    }
  }
  .lang-set-wrapper {
    position: fixed;
    right: 0;
    top: 0;
  }
  .login-layout__desc {
    margin-top: 12px;
    margin-bottom: 0;
    color: rgba(0, 0, 0, .45);
    font-size: 14px;
  }
  .login-layout__bd {
    padding: 32px 0 20px;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .cube-inner, .cube-inner li {
    position: absolute;
    display: block;
  }
  .cube-inner {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: -25px 0;
    top: 50%;
    left: 50%;
    transform-origin: 25px 25px;
    margin: 7px 0 0 -25px;
    transform: rotateX(-33.5deg) rotateY(45deg);
    transform-style: preserve-3d;
    animation: fastspin 10s ease-in-out infinite 2s;
  }
  @keyframes fastspin {
    0% {
      transform: rotateX(-33.5deg) rotateY(45deg);
    }
    10%, 100% {
      transform: rotateX(-33.5deg) rotateY(-315deg);
    }
  }
  .cube-inner .front {
    transform: translateZ(25px);
  }
  .cube-inner .back {
    transform: rotateX(-180deg) translateZ(25px);
  }
  .cube-inner .right {
    transform: rotateY(90deg) translateZ(25px);
  }
  .cube-inner .left {
    transform: rotateY(-90deg) translateZ(25px);
  }
  .cube-inner .top {
    transform: rotateX(90deg) translateZ(25px);
  }
  .cube-inner .bottom {
    transform: rotateX(-90deg) translateZ(25px);
  }
  .cube-inner .back, .cube-inner .front, .cube-inner .left, .cube-inner .right, .cube-inner .top {
      background: radial-gradient(transparent 30%,rgba(5,17,53,.2) 100%);
  }
  .cube-inner li {
    width: 50px;
    height: 50px;
    transition: transform 1s ease-in-out;
  }
  .cube-inner li:after {
    content: "";
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    backface-visibility: hidden;
    /*background-color: rgba(16,58,177,.5);*/
    transition: transform 1s ease-in-out;
}
.outside {
  margin-top: 4px;
  transform: scale(.2);
    height: 20px;
    z-index: 1;
}
.bagimg {
    background-image: url(../assets/logo_bga.png);
    background-size: 100% 100%;
    width: 40px;
    height: 40px;
    position: relative;
    // margin-top: 40px;
}
.cube-inner .back {
  background: #267ce1;
}
.cube-inner .right {
  background: #a3c4ef;
}
.cube-inner .bottom {
  background: #1d0ea2;
}
</style>
